import { appClientsService } from '@aslanpay/portal-common-lib';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface DeleteAppClientParams {
  companyId: string;
  clientId: string;
}

const useDeleteAppClient = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ clientId }: DeleteAppClientParams) => {
      return appClientsService.deleteAppClient(clientId);
    },
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['fetchCognitoAppClients', companyId] });
    },
  });
};

export default useDeleteAppClient;
